import shipvistaAPI from "./shipvistaAPI";

export const getAllUserSubscription = () =>
  shipvistaAPI.get(`/subscription/GetAllSubScriptionPlans`);
